import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const CreateNonTeachingStaffLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'CreateNonTeachingStaff' */ './components/CreateNonTeachingStaff'
		)
);

export default (store) => {
	return {
		path: 'nonteaching-staff/create',
		element: (
			<AsyncLoading
				component={
					<CreateNonTeachingStaffLazy featureFlag="FeatureFlag:TransportModule" />
				}
			/>
		),
	};
};
